import { render, staticRenderFns } from "./PaymentLinkWrapper.vue?vue&type=template&id=7b564320"
import script from "./PaymentLinkWrapper.vue?vue&type=script&lang=js"
export * from "./PaymentLinkWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports